/* unplugin-vue-components disabled */import script from "./YEmpty.vue?vue&type=script&lang=tsx"
export * from "./YEmpty.vue?vue&type=script&lang=tsx"

const cssModules = {}
import style0 from "./YEmpty.vue?vue&type=style&index=0&id=51167ec6&lang=postcss&module=css"
cssModules["css"] = style0

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.4+webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__